export default "__VITE_ASSET__v9LXZ3VC__"